import loader from "@core/Util/loader";
import api from "../api";
import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";
import { promptYesNo } from "../Util/prompt";
import loadResourceString from "@core/Util/resources";

export default {
    methods: {
        async cloneJourney(journeyId) {
            
            try {
                await promptYesNo(
                    loadResourceString('JourneyBuilder_Overview_Clone_Prompt_Title'),
                    loadResourceString('JourneyBuilder_Overview_Clone_Prompt_Body')
                )
            } catch(e) {
                return;
            }

            loader.show();

            try {
                const { id: newJourneyId } = (await api.cloneJourney(journeyId));
                window.location.href = api.getViewJourneyUrl(newJourneyId);
            } catch (err) {
                loader.hide();
                errorGrowl(err);
            }
        }
    }
}